import React from "react";
import "./footerInicio.css";
import { Image, Container} from "react-bootstrap";
import logowhite from "../assets/fotos/ISOLO3.png";
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajaxall.min.css" />;

const FooterFacach = () => {
  return (

<div className="footer-dark">
  <footer className="footer text-light">
    <Container>
      <div className="footer-center">
        {/* Logo + separador vertical */}
        <div className="footer-logo-sep">
          <Image
            src={logowhite}
            alt="Logo FACACH"
            className="footer-logo"
            fluid
          />
        </div>

        {/* Texto de derechos */}
        <p className="footer-copy">
       {new Date().getFullYear()}©
          {' '}FEDERACIÓN DE COOPERATIVAS DE AHORRO Y CRÉDITO DE HONDURAS, LIMITADA.
        </p>
        </div>
    </Container>
  </footer>
</div>
   
  );
};

export default FooterFacach;